import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { Mixer } from '../../../store/entities/mixers/mixers.types';
import { APIManagerConfig } from '../apiManager';

const MixerServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getMixerList: (): Promise<Mixer[]> => HTTPBase.get(`farm/${config.farmId}/mixers`).then((res) => res.data),
    getMixerById: (id: string): Promise<Mixer[]> =>
      HTTPBase.get(`farm/${config.farmId}/mixers/${id}`).then((res) => res.data),
    createMixer: (mixer: Mixer, formName: FormName): Promise<Mixer> =>
      HTTPBase.post(`farm/${config.farmId}/mixers`, mixer, { headers: { formName } }).then((res) => res.data),
    deleteMixer: (mixerId: string, formName: FormName): Promise<Mixer> =>
      HTTPBase.delete(`farm/${config.farmId}/mixers/${mixerId}`, { headers: { formName } }).then((res) => res.data),
    editMixer: (mixer: Mixer, formName: FormName): Promise<Mixer> =>
      HTTPBase.patch(`farm/${config.farmId}/mixers/${mixer.id}`, mixer, { headers: { formName } }).then(
        (res) => res.data,
      ),
    callMixerStatus: (id: string, formName: FormName) =>
      HTTPBase.post(`farm/${config.farmId}/mixers/${id}/refreshstatus`, {}, { headers: { formName } }).then(
        (res) => res.data,
      ),
    getMixerStatus: (id: string, formName: FormName) =>
      HTTPBase.get(`farm/${config.farmId}/mixers/${id}/status`, { headers: { formName } }).then((res) => res.data),
  };
};

export default MixerServiceFactory;
